<template>
  <div class="horse card">
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-md-4">
          <div v-if="horse.thumbnail">
            <a :href="horse.detail_url">
              <img :src="horse.thumbnail" />
            </a>
          </div>
        </div>
        <div class="col-12 col-md-8 content">
          <div class="">
            <h2><a :href="horse.detail_url">{{ horse.name }}</a></h2>
            <div v-if="horse.price > 0" class="price mb-3"><span class="old_price" v-if="horse.old_price > 0">{{ formatCurrency(horse.old_price) }}</span>{{ formatCurrency(horse.price) }}</div>
            <div v-else class="price mb-3">Call for Price</div>
            <div v-if="horse.color"><strong>Color:</strong> {{ horse.color }}</div>
            <div v-if="horse.pattern"><strong>Pattern:</strong> {{ horse.pattern }}</div>
            <div v-if="horse.height"><strong>Height:</strong> {{ horse.height }}"</div>
            <div v-if="horse.registries.length">
              <strong v-if="horse.registries.length === 1">Registry:</strong>
              <strong v-else>Registries:</strong>
              {{ horse.registries.join(', ') }}
            </div>
            <div class="mt-3"><a :href="horse.detail_url" class="btn btn-primary btn-sm">Learn More</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HorseCard',
  props: {
    horse: Object
  },
  methods: {
    formatCurrency: function (price) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      })

      return formatter.format(price)
    }
  }
}
</script>
